
class CartConsent extends HTMLElement {
  connectedCallback() {
    this.updateUrl = this.dataset.updateUrl || '/cart/update.js';
    this.version = this.dataset.version || '';
    this.dirty = false;
    this._submitting = false;

    this.checkboxes = Array.from(this.querySelectorAll('.cart-consent__cb'));
    this.requiredBoxes = this.checkboxes.filter((cb) => cb.hasAttribute('data-required'));
    this.errorEl = this.querySelector('[data-consent-error]');

    const scope = this.parentElement || document;
    const ctas = scope.querySelector('.cart__ctas');
    this.checkoutButton = ctas ? ctas.querySelector('.cart__checkout-button') : null;

    this.handleChange = this.handleChange.bind(this);
    this.handleCheckout = this.handleCheckout.bind(this);
    this.checkboxes.forEach((cb) => cb.addEventListener('change', this.handleChange));
    if (this.checkoutButton) this.checkoutButton.addEventListener('click', this.handleCheckout);

    this.sync();
  }

  disconnectedCallback() {
    this.checkboxes.forEach((cb) => cb.removeEventListener('change', this.handleChange));
    if (this.checkoutButton) this.checkoutButton.removeEventListener('click', this.handleCheckout);
  }

  allRequiredChecked() {
    return this.requiredBoxes.every((cb) => cb.checked);
  }

  sync() {
    const ok = this.allRequiredChecked();
    if (this.checkoutButton) this.checkoutButton.disabled = !ok;
    if (this.errorEl) {
      const show = this.dirty && !ok;
      // Text erst beim Einblenden einsetzen → role="alert" wird zuverlässig vorgelesen.
      if (show && this.errorEl.hidden) this.errorEl.textContent = this.errorEl.dataset.msg || '';
      this.errorEl.hidden = !show;
    }
    this.toggleAttribute('data-incomplete', !ok);
  }

  handleChange() {
    this.dirty = true;
    this.sync();
    this.commit();
  }

  // Schreibt die Zustimmung in cart.attributes (true/false je Häkchen + Zeitstempel/Version,
  // sobald vollständig). keepalive: läuft auch über einen Seitenwechsel hinaus zu Ende.
  // Gibt das fetch-Promise zurück, damit der Checkout-Klick darauf warten kann.
  commit() {
    const ok = this.allRequiredChecked();
    const attributes = {};
    this.checkboxes.forEach((cb) => {
      attributes[cb.dataset.key] = cb.checked ? 'true' : 'false';
    });
    attributes.zustimmung_zeitpunkt = ok ? new Date().toISOString() : '';
    attributes.zustimmung_version = ok ? this.version : '';
    return fetch(this.updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
      keepalive: true,
    }).catch(() => {
    });
  }


  handleCheckout(event) {
    if (this._submitting || !this.allRequiredChecked()) return;
    const form = this.checkoutButton.form;
    if (!form || typeof form.requestSubmit !== 'function') return;
    event.preventDefault();
    this._submitting = true;
    this.commit().finally(() => form.requestSubmit(this.checkoutButton));
  }
}

if (!customElements.get('cart-consent')) {
  customElements.define('cart-consent', CartConsent);
}
